export const getMarketServiceBaseUrl = () => {
    return 'https://market-production-api.trendex.vip';
}

export const marketServiceUrl = `${getMarketServiceBaseUrl()}/market`